import TemplatesEmpty from 'public/assets/img/templatesEmpty.svg';
import CTypography from 'components/CTypography';
import { EmptyCnt } from 'pages/Templates/MyTemplates/emptyStates/myTemplates/styles';

function FolderTemplatesEmpty() {
  return (
    <EmptyCnt>
      <div className="content">
        <img alt="templates" src={TemplatesEmpty} />
        <CTypography className="title">No templates</CTypography>
        <CTypography className="subtitle">
          There are no templates in this folder. To add a template, you can
          either choose a folder or directly drag-and-drop templates into this
          folder.
        </CTypography>
      </div>
    </EmptyCnt>
  );
}

export default FolderTemplatesEmpty;
